module.exports = __webpack_public_path__ + "img/NM.d08a9c72.png";